<template lang="pug">
    .card-teaser(v-if="display === 'card'" :class="{ hover: mouseover }")
        router-link(
            v-if="route"
            :to="route"
            @mouseover.native="hover"
            @mouseleave.native="blur"
        )
            figure
                img(v-if="showImage" v-lazy="image" :title="title")
        .no-link(v-else)
            figure
                img(v-if="showImage" v-lazy="image" :title="title")
        p.topic.is-uppercase.has-text-weight-bold(v-if="topic")
            | {{ topic }}
        h3.is-size-5(v-if="title")
            | {{ title }}
        .date.has-text-weight-bold(v-if="date") {{ date }}
        .bait(v-if="text")
            div(v-line-clamp:24="3")
                p.content(v-html="striptags(text)")
        .link(v-if="route")
            router-link(:to="route") Weiterlesen ...
    .row-teaser(v-else :class="{ hover: mouseover }")
        .image
            router-link(
                v-if="route"
                :to="route"
                @mouseover.native="hover"
                @mouseleave.native="blur"
            )
                figure
                    img(v-if="showImage" v-lazy="image" :title="title")
            .no-link(v-else)
                figure
                    img(v-if="showImage" v-lazy="image" :title="title")
        .text
            .topic-wrap
                p.topic.is-uppercase.has-text-primary.has-text-weight-bold(v-if="topic || referencedCmsName")
                    span.left(v-if="topic") {{ topic }}
                    span.right(v-if="referencedCmsName") {{ referencedCmsName }}
                .date.has-text-weight-bold(v-if="date") {{ date }}

            h3.is-size-4(v-if="title")
                | {{ title }}
            .bait(v-if="text")
                div(v-line-clamp:24="topic ? 4 : 5")
                    p.content(v-html="striptags(text)")
            .link(v-if="route")
                router-link(:to="route") Weiterlesen ...
</template>

<script>

import _ from 'lodash'
import striptags from 'striptags'
import { fromUnixTime, format, parseISO } from 'date-fns';
import { mapGetters } from 'vuex'

export default {
    name: 'Teaser',
    data() {
        return {
            delay: 150,
            mouseover: false,
            showImage: true,
        }
    },
    props: {
        teaser: {
            type: Object,
            required: true,
        },
        showTopic: {
            type: Boolean,
            default: false,
        },
        origin: {
            type: String|Number,
            required: true,
        },
        display: {
            type: String,
            default: 'row',
        },
        showDate: {
            type: Boolean,
            default: false,
        },
    },
    watch: {
        image() {
            // ugly workaround
            this.showImage = false
            this.$nextTick(() => {
                this.showImage = true
            })
        },
    },
    computed: {
        image() {

            let image

            if (this.teaserSection) {
                const content = this.teaserSection.contents.find(content => content.key === 'image')
                if (content && content.images.length) image = content.images[0]
            }

            if (! image && this.sections.length) {
                this.sections.forEach(section => {
                    if (image) return

                    const content = section.contents.find(content => content.key === 'image')
                    if (content && content.images.length) image = content.images[0]
                })
            }

            if (! image) return false

            const storageRoute = _.trim(`${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_PUBLIC_STORAGE_ROUTE}`, '/')

            let fit = _.get(image, 'pivot.fit') || 'fit=crop&crop=focalpoint&x=.5&y=.5&z=1.1111111111'
            const parameters = {
                // ... _.get(fit.match(/x=(?<fx>[0-1]?\.?[0-9]*)/), 'groups'),
                // ... _.get(fit.match(/y=(?<fy>[0-1]?\.?[0-9]*)/), 'groups'),
                // ... _.get(fit.match(/z=(?<fz>[1-9]+\.?[0-9]*)/), 'groups'),
                ... _.get(fit.match(/w=(?<w>[0-9]+\.?[0-9]*)/), 'groups'),
                ... _.get(fit.match(/h=(?<h>[0-9]+\.?[0-9]*)/), 'groups'),
            }
            let { w, h } = parameters

            let width, height
            let aspectRatio = 4 / 3

            width = 320
            height = width / aspectRatio

            if (w && h) {
                fit = fit.replace(/w=([0-9]+\.?[0-9]*)/, `w=${width}`).replace(/h=([0-9]+\.?[0-9]*)/, `h=${height}`)
            } else if (! w && ! h) {
                fit += `&w=${width}&h=${height}`
            }

            return {
                src: `${storageRoute}/images/${image.id}/${image.name}?${fit}`,
                error: `${storageRoute}/images/${image.id}/${image.name}?${fit}&preview=greyscale`,
                loading: `${storageRoute}/images/${image.id}/${image.name}?${fit}&preview=blur`,
            }
        },
        route() {
            let name

            let categoryKey = _.get(this.teaser, 'category.key')
            const key = this.teaser.key

            // let categoryPath;
            switch (categoryKey) {
                case 'news':
                    // categoryPath = `/news/${key}`;
                    name = 'aktuelles';
                    break;

                case 'headerNews':
                    // categoryPath = `/news/${key}`
                    name = 'news';
                    break;

                case 'events':
                    // categoryPath = `/events/${key}`
                    name = 'events';
                    break;

                case 'archiv':
                    // categoryPath = `/events/${key}`
                    name = 'archiv';
                    break;

                default:
                    name = 'not-found';
                    break;
            }

            let route = {
                name,
                params: { key },
                query: {
                    origin: this.origin
                }
            };

            let src
            const referencedPost = _.get(this.teaser, 'category.cms.id') !== this.cms.id
            if (referencedPost) src = _.get(this.teaser, 'category.cms.id')
            else src = _.get(this.reference, 'menuItem.menu.cms.id')
            if (src) route.params.src = src

            return route
        },
        topic() {
            if (this.showTopic) return _.get(this.teaser, 'category.name')
        },

        date() {
            const createdAt = _.get(this.teaser, 'created_at');

            if (createdAt && this.showDate) {
                const date = parseISO(format(fromUnixTime(createdAt), 'yyyy-MM-dd'));
                const formdate = format(new Date(date), 'dd.MM.yyyy');

                return formdate;
            } else {
                return false
            }
            //return new Date();
        },
        title() {
            return _.get(this.teaser, 'title')
        },
        referencedCmsName() {
            let name
            const referencedCmsID = _.get(this.teaser, 'category.cms.id')
            if (referencedCmsID && referencedCmsID !== this.cms.id) {
                name = _.get(this.teaser, 'category.cms.name')
            }
            return name
        },
        text() {
            let content
            if (this.teaserSection) {
                content = this.teaserSection.contents.find(content => content.key === 'teaser')
            }

            if (! (content && content.text) && this.postSection) {
                content = this.postSection.contents.find(content => content.key === 'content')
            }

            // if (this.display === 'card') {
            //     text = truncate(content.text, 18, { byWords: true })
            // } else {
            //     text = truncate(content.text, 32, { byWords: true })
            // }

            return content.text
        },
        sections() {
            return this.teaser.sections
        },
        teaserSection() {
            return this.sections.find(section => section.key === 'category-page-teaser')
        },
        postSection() {
            return this.sections.find(section => section.key === 'post')
        },
        ...mapGetters( {
            reference: 'currentPage/reference',
            cms: 'CMS',
        })
    },
    methods: {
        hover() {
            this.$emit('focus', this.item)
            this.mouseover = true
        },
        blur() {
            setTimeout(() => {
                this.$emit('blur', this.item)
                this.mouseover = false
            }, this.delay);
        },
        striptags(html) {
            html = html.replace(/<p[^>]*>/g, '').replace(/<\/p>/g, '<br />')
            return striptags(html, ['a', 'i', 'u', 'b', 'em', 'strong', 'span', 'br'])
        }
    },
}
</script>

<style lang="sass" scoped>

    @import "~bulma/sass/utilities/mixins";
    @import '~@/assets/sass/variables';

    .card-teaser, .row-teaser
        .topic-wrap
            display: flex
            .date
                margin-left: auto

        text-align: initial
        h3
            line-height: 1.3
            color: $primary
            font-weight: 600
            margin-bottom: 10px
        .topic
            font-size: .85rem
            margin-bottom: 10px
        .date
            font-size: .85rem
        .bait
            margin-bottom: 10px
            div
                word-break: normal !important
                br + br
                    display: none
        figure
            position: relative
            width: 100%
            padding-bottom: 75% // 9 / 16
            display: block
            background: #D8D8D8
            border-radius: 20px
            margin-bottom: 20px
            transition: transform .8s ease
            img
                border-radius: 20px
                position: absolute
                width: 100%
                max-height: 100%
                left: 0
                top: 0
                box-shadow: $box-shadow-2
                transition: box-shadow .8s ease
        &.hover
            a figure
                transform: scale(1.04)
                img
                    box-shadow: $box-shadow-3
    +tablet
        .row-teaser
            display: flex
            flex-direction: row
            .image
                flex-basis: 320px
                flex-grow: 0
                flex-shrink: 0
                figure
                    margin-bottom: 0
            .topic
                display: flex
                flex-grow: 1
                justify-content: space-between
                margin-bottom: 0
                .right
                    color: rgb(87, 87, 85)
            .date
                padding-left: 1rem
            .text
                margin-left: 20px
                flex-grow: 1
                display: flex
                flex-direction: column
                .bait
                    flex-grow: 1
</style>
